const verificationConstant = {
  photo: {
    title: "profile picture verification",
    description: "For showroom access",
    modalProps: {
      title: "Upload profile picture",
      note: {
        title: "Legal Usage:",
        description:
          "You are close to become a “Verified member”. This photo will only be used for entering our showroom security and is purely to confirm your identity prior to an appointment. Please upload a picture of yourself - it will be the easiest smile you’ll ever have to wear. ",
      },
    },
  },
  id: {
    title: "ID verification",
    description: "For transaction above £ 10,000",
    modalProps: {
      title: "Upload ID",
      note: {
        title: "Legal Usage:",
        description:
          "Accepted KYC documents: Passport / Driver’s license / National Identity Card. \nBy uploading the requested documents, you are confirming your identity and helping us comply with regulatory requirements.",
      },
    },
  },
};

export default verificationConstant;
